import DaoBase from "./base";
import _ from "underscore";
import {$shutils} from "../../libs/snnh/snnh";
import {rd} from "../../vars/rd";

class DaoMent extends DaoBase {
    seq;
    type;
    cid;
    vid;
    order;
    playtime;
    sample;
    artist;
    title;
    dn;
    location;
    fileinfo;
    filesize;
    fileversion;
    date;
    time;
    use_start;
    use_end;
    level;

    category;
    script;

    constructor(json=null) {
        super(json);
    }

    is_match(code) {
        return code && _.indexOf(['AL', this.category], code) > -1;
    }

    /**
     * @returns {string}
     */
    get category_name() {
        return rd.category.ment.hasOwnProperty(this.category) ? rd.category.ment[this.category] : '기타';
    }

    get datetime() {
        if(this.time) {
            return $shutils.toDate(`${$shutils.toDateString()} ${this.time}`);
        } else return null;
    }

    /**
     * is am or pm
     */
    get is_pm() {
        const date = this.datetime;
        if(date) {
            return date.getHours() > 11;
        } else return false;
    }
}

export default DaoMent;


// WEBPACK FOOTER //
// ./src/modules/dao/ment.js